/* eslint-disable */
export default {
  forward: 'Renvoyer',
  ignore: 'Ignorer',
  toVoicemail: 'Vers la messagerie vocale',
  answer: 'Répondre',
  endAndAnswer: 'Terminer et répondre',
  holdAndAnswer: 'Mettre en attente et répondre',
  custom: 'Personnaliser',
  more: 'Plus',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
